// extracted by mini-css-extract-plugin
export default {"slides":"index_slides_Yacqp","swiperItemText":"index_swiperItemText_aFe-a","dot":"index_dot_t0m2a","current":"index_current_ghjvk index_dot_t0m2a"};